import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import IndexPage from '../views/IndexPage.vue'
import TabsPage from '../views/TabsPage.vue'
import { trackNavigationFromRoute } from '@/composables/navigationVisits'

const isLogged = () => localStorage.getItem('token') !== null


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: () => (isLogged() ? 'tabs/clases' : '/login'),
    meta: { requiredAuth: false }
  },
  {
    path: '/login',
    component: () => import('@/views/LoginPage.vue')
  },
  {
    path: '/password-recovery',
    name: 'Recuperar contraseña',
    component: () => import('@/views/PasswordRecoveryPage.vue')
  },
  {
    path: '/confirmar-asistencia/:clase_id',
    name: 'Confirmar asistencia',
    component: () => import('@/views/Clase/ConfirmarAsistenciaPage.vue'),
    meta: { requiredAuth: true }
  },
  {
    path: '/clases/:clase_id',
    name: 'Acceso clase',
    component: () => import('@/views/ClaseAccesoPage.vue'),
    meta: { requiredAuth: true }
  },
  {
    path: '/widgets/',
    component: IndexPage,
    children: [
      {
        path: 'registroEventos/:clase_id',
        name: 'registroEventos',
        component: () => import('@/views/Clase/RegistroEventos.vue'),
      },
    ]
  },

  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {
        path: 'inicio',
        component: () => import('@/views/InicioPage.vue'),
        name: 'Galidancia',
        meta: { requiredAuth: true }
      },
      {
        path: 'asientos',
        name: 'Pagos',
        component: () => import('@/views/AsientosPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'cart',
        name: 'Pagar Actividades',
        component: () => import('@/views/CartPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'tienda',
        name: 'Tienda Galidancia',
        component: () => import('@/views/TiendaPage.vue'),
        meta: { requiredAuth: false }
      },
      {
        path: 'tienda/producto/:id',
        name: 'Producto',
        component: () => import('@/views/TiendaProductoPage.vue'),
        meta: { requiredAuth: false }
      },
      {
        path: 'clases/:clase_id',
        redirect: (to) => `/clases/${to.params.clase_id}`,
        meta: { requiredAuth: true }
      },
      {
        path: 'clases',
        component: () => import('@/views/ClasesPage.vue'),
        name: 'Mis clases',
        meta: { requiredAuth: true }
      },
      {
        path: 'calculadora',
        component: () => import('@/views/CalculadoraPage.vue'),
        name: 'Calculadora de precios',
        meta: { requiredAuth: true }
      },
      {
        path: 'coordinadores',
        component: () => import('@/views/Clase/coordinadoresList.vue'),
        name: 'Coordinadores',
      },
      {
        path: 'profesores',
        component: () => import('@/views/Clase/profesoresList.vue'),
        name: 'Profesores',
      },
      {
        path: 'horarios',
        redirect: '/tabs/probar',
      },
      {
        path: 'eventos',
        component: () => import('@/views/EventosPage.vue'),
        name: 'Próximos eventos',
      },
      {
        path: 'mensajes',
        component: () => import('@/views/MensajesPage.vue'),
        name: 'Mensajes',
        meta: { requiredAuth: true }
      },
      {
        path: 'mensajes/chat/:partner_id',
        name: 'Chat mensajes',
        component: () => import('@/views/MensajesChatPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'probar',
        component: () => import('@/views/Clase/probarList.vue'),
        name: 'Horarios',
        meta: { requiredAuth: true }
      },
      {
        path: 'necesidades',
        component: () => import('@/views/DeteccionNecesidades.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'recuperar',
        component: () => import('@/views/RecuperarPage.vue'),
        name: 'Recuperar',
        meta: { requiredAuth: true }
      },
      {
        path: 'aulas',
        component: () => import('@/views/Clase/aulasList.vue'),
        name: 'Aulas',
      },
      {
        path: 'profile',
        component: () => import('@/views/profilePage.vue'),
        name: 'Yo',
      },
      {
        path: 'acreditacion',
        component: () => import('@/views/AcreditacionPage.vue'),
        name: 'Acreditación',
        meta: { requiredAuth: true }
      },
      {
        path: 'asistencias/:clase_id?',
        component: () => import('@/views/Clase/AsistenciasPage.vue'),
        name: 'Mis asistencias',
        meta: { requiredAuth: true }
      },
      {
        path: 'ayudar/:sesion_id/:user_id?',
        component: () => import('@/components/Clase/AyudanteView.vue'),
        name: '¿Puedes ayudar?',
        meta: { requiredAuth: false }
      },
      {
        path: 'home',
        component: () => import('@/views/HomePage.vue'),
        name: 'Home',
        meta: { requiredAuth: true }
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta?.requiredAuth)

  if (requiresAuth && !isLogged()) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

router.afterEach((to) => {
  if (!isLogged()) return;
  if (!to.path.startsWith('/tabs/')) return;
  if (to.path.startsWith('/tabs/inicio')) return;
  trackNavigationFromRoute(to.path);
});

export default router
